import { render, staticRenderFns } from "./UserRolesChangesExplainer.vue?vue&type=template&id=8d8639a4&scoped=true&"
import script from "./UserRolesChangesExplainer.vue?vue&type=script&lang=ts&"
export * from "./UserRolesChangesExplainer.vue?vue&type=script&lang=ts&"
import style0 from "./UserRolesChangesExplainer.vue?vue&type=style&index=0&id=8d8639a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8639a4",
  null
  
)

export default component.exports